import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import { Container, Row } from 'reactstrap';
import './ScheduleDisconnectDatePage.scss'
import { goToPage, stepParams, setScheduleDateToDisconnect, setHasDateChangedToDisconnect } from '../../../DisconnectServiceSlice'
import SelectInput from '../../../../../Shared/SelectInput/SelectInput'
import Dates from '../../DisconnectCommonParts/datesToDisconnect'
import BtnSubmit from '../../../../../Shared/Buttons/BtnSubmit';
import gaParams from '../../../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../../../utilities/analytics/tracking';

function ScheduleDisconnectDatePage(props) {

    const [comparer, setComparer] = useState(true);
    const [selectedDate, SetSelectedDate] = useState("");
    
    const d = Dates(31); 
    const keys = d.options.map(date => date.key);
    
    const defaultDateVal = props.summarizeUserDisconnectDetails.timeDisconnectScheduled != "" ? props.summarizeUserDisconnectDetails.timeDisconnectScheduled : d.options[0].date;
    
    let today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = today.getFullYear();
    today = dd + '/' + mm + '/' + yyyy;

    function onChange(val) {
        props.setScheduleDateToDisconnect(val);
        val = val.substring(0, 10);
        let selectedDate = val.replaceAll("/", "");
        let thisDay = today.replaceAll("/", "");
        SetSelectedDate(val)
        if(Number(selectedDate) === Number(thisDay)) {
            setComparer(true);
        }
        else {
            setComparer(false);
            props.setHasDateChangedToDisconnect(true)
        }
    }

    useEffect(() => {
        if (typeof window.scrollTo === "function") { 
            window.scrollTo(0, 0);
        } 
        gaEvent(gaParams.DISCONNECT_ENTER_SCHEDULE_WHEN_WE_PART_PAGE_CELLULAR.category, gaParams.DISCONNECT_ENTER_SCHEDULE_WHEN_WE_PART_PAGE_CELLULAR.eventType, gaParams.DISCONNECT_ENTER_SCHEDULE_WHEN_WE_PART_PAGE_CELLULAR.eventParams);
      }, [])

    useEffect(() => {

    },[comparer, selectedDate])

    function redirect() {
        if(props.summarizeUserDisconnectDetails.timeDisconnectScheduled == '') {
            gaEvent(gaParams.DISCONNECT_CLICK_CONTINUE_IN_SCHEDULE_WHEN_WE_PART_PAGE_CELLULAR.category, gaParams.DISCONNECT_CLICK_CONTINUE_IN_SCHEDULE_WHEN_WE_PART_PAGE_CELLULAR.eventType, "date not changed")
            props.setScheduleDateToDisconnect(today);
        }
        else {
            gaEvent(gaParams.DISCONNECT_CLICK_CONTINUE_IN_SCHEDULE_WHEN_WE_PART_PAGE_CELLULAR.category, gaParams.DISCONNECT_CLICK_CONTINUE_IN_SCHEDULE_WHEN_WE_PART_PAGE_CELLULAR.eventType, "date changed")
        }
        props.goToPage({ page: 'SUMMARIZE_DISCONNECT_CELLULAR_PAGE', params: { ...stepParams, hideHeader: true } })
    }

    return (
        <Container className="ScheduleDisconnectDatePage-root">
            <Row className="header-row">
                <h3 className="header">מתי נבצע את הניתוק?</h3>
            </Row>
            <Row className="input-date-row">
                <div className="bigTxt">אם לא יוגדר מועד אחר, הניתוק יבוצע מיידית</div>
                <div className="smallTxt">לקביעת מועד אחר לניתוק:</div>
                <SelectInput 
                    // error={props.error} 
                    options={d.options} 
                    dataKey={keys}
                    dataValue="date"
                    id="input-date"
                    name="selectInput"
                    defaultText={defaultDateVal}
                    //placeholder={d.options[0].date} 
                    //value = {defaultDateVal}
                    onChange={(e) => onChange(e.target.value /*textContent*/)}  
                    /> 
            </Row>
            <Row className="btn-row">
                    <BtnSubmit text="המשך" onclick={() => redirect()}/>
            </Row>
            {selectedDate != "" && comparer == false && 
            <Row className="warning-row">
                <span className="txt">הניתוק יתבצע מהשעה 21:00 ואילך ביום המבוקש</span>
            </Row>}
        </Container>
    )
}

const mapStateToProps = (state) => ({
    stepInProcess: state.disconnectServicesBlock.stepInProcess,
    stepParams: state.disconnectServicesBlock.stepParams,
    summarizeUserDisconnectDetails: state.disconnectServicesBlock.summarizeUserDisconnectDetails
});
  
const mapDispatchToProps = {
    goToPage,
    setScheduleDateToDisconnect,
    setHasDateChangedToDisconnect
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleDisconnectDatePage);